export default "__VITE_ASSET__Cqd0Apwq__"